
    import './styles.scoped.css';
    export default {
  "toggle-button": "awsui_toggle-button_1a743_105bz_9",
  "variant-normal": "awsui_variant-normal_1a743_105bz_9",
  "pressed": "awsui_pressed_1a743_105bz_18",
  "variant-icon": "awsui_variant-icon_1a743_105bz_24"
};
  